import React from "react";
import Hero from "../../components/Hero/Hero";
import GetInTouch from "../../components/GetInTouch/GetInTouch";

export default function CareersPage() {
  function IntroSection() {
    return (
      <div className="hero-container">
        <p className="subtitle">Join Us</p>
        <h1>Join Venti Maris</h1>
        <p className="paragraph">
          Join Venti Maris and be part of a team that drives the future of
          offshore energy logistics. We are always looking for talented and
          passionate individuals who want to contribute to the growth of
          offshore renewable energy. As a dynamic company at the forefront of
          marine logistics and engineering, we offer exciting opportunities to
          work on groundbreaking offshore wind projects around the world.
        </p>
      </div>
    );
  }

  function TypicalRolesSection() {
    const roles = [
      {
        role: "Marine Project Managers",
        description:
          "Oversee end-to-end transport projects, coordinating between clients, vessel operators, and engineering teams to ensure successful delivery.",
      },
      {
        role: "Naval Architects & Structural Engineers",
        description:
          "Develop innovative seafastening designs, stability analyses, and custom engineering solutions for transporting massive offshore structures.",
      },
      {
        role: "Marine Operations Coordinators",
        description:
          "Plan and execute voyage logistics, from routing and weather assessments to on-site supervision of load-outs and offloads.",
      },
      {
        role: "Logistics and Supply Chain Specialists",
        description:
          "Manage the intricate supply chain of heavy transport – scheduling shipments, handling customs and port operations, and ensuring timely equipment availability.",
      },
      {
        role: "Health, Safety & Quality Officers",
        description:
          "Ensure that all operations meet the highest safety standards and that our quality management processes are adhered to throughout project execution.",
      },
    ];
    return (
      <div>
        <h2>Typical roles at Venti Maris include:</h2>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {roles.map((roleItem, idx) => (
            <li key={idx} className="mt-4">
              <p className="text-lg font-bold">{roleItem.role}</p>
              <p>{roleItem.description}</p>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  function WhatWeOfferSection() {
    const offers = [
      {
        title: "Dynamic Work Environment",
        description:
          "Experience a mix of office and on-site project work, collaborating with international teams and maritime experts.",
      },
      {
        title: "Growth & Development",
        description:
          "Ongoing training programs, mentorship from industry veterans, and clear advancement paths in a growing company.",
      },
      {
        title: "Inclusive Culture",
        description:
          "A supportive, diverse workplace that values new ideas and perspectives, reflecting the global nature of our business.",
      },
      {
        title: "Competitive Benefits",
        description:
          "Comprehensive health and insurance plans and generous leave policies to support work-life balance.",
      },
    ];
    return (
      <div>
        <h2>What We Offer</h2>
        <p>
          Our company culture is built around continuous improvement and
          employee well-being. Team members enjoy opportunities for professional
          development and the reward of contributing to world-changing offshore
          projects. We provide:
        </p>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {offers.map((offer, idx) => (
            <li key={idx} className="mt-4">
              <p className="text-lg font-bold">{offer.title}:</p>
              <p>{offer.description}</p>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  function HowToApplySection() {
    return (
      <div className="border-t pt-20 equal-flex">
        <div>
          <h2>How to Apply</h2>
          <p>
            Even if we are not advertising a specific position, we welcome
            general expressions of interest. If you are driven to make a
            difference in offshore wind logistics, please send your CV and a
            brief cover letter to{" "}
            <a
              className="text-main-light text-inherit-size underline"
              href="mailto:"
            >
              contact@ventimaris.com
            </a>
            .
          </p>
        </div>
        <div></div>
      </div>
    );
  }

  return (
    <div>
      <IntroSection />
      <div className="body-container">
        <TypicalRolesSection />
        <WhatWeOfferSection />
        <HowToApplySection />
        <GetInTouch
          text={{
            heading: "Join Us",
            paragraph:
              "Embark on a rewarding career with Venti Maris, where your skills will help connect nations to sustainable energy and your ideas will steer the future of marine transport.",
          }}
        />
      </div>
    </div>
  );
}
